// SuppliersHome.tsx
import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import React, { FC, useEffect, useState, useCallback, useRef, useMemo } from 'react'
import { PageLink, PageTitle } from '../../_metronic/layout/core'
import { Link } from 'react-router-dom'
import { useMutation, useQueryClient } from 'react-query'
import { KTCard, toAbsoluteUrl } from '../../_metronic/helpers'
import { KTCardBody } from '../../_metronic/helpers'
import { KTSVG } from '../../_metronic/helpers'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Maintable } from '../tables/Maintable'
import { Updatesupplier } from './modals/Updatesupplier'

import { Deletesupplier } from './modals/Deletesupplier'
import { ItemsSummary } from '../topdashboard/ItemsSummary'
import { getSuppliers } from '../apis/Loadalltabledata'
import { useSuppliers, useSuppliersSummary, useSuppliersWithOutstandingPayments, useDeleteSupplier } from '../contextProviders/Atomqueryprovider'
import CountUp from 'react-countup'
import LoadingBar from 'react-top-loading-bar'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { Column } from 'react-table'
import { useAuth } from '../../app/modules/auth'
import { useWindowWidth } from '@react-hook/window-size/throttled'
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isBetween from 'dayjs/plugin/isBetween';
import io from 'socket.io-client'
import { useDashboard } from '../contextProviders/Dashboardcontext'
import { AddSupplier } from './modals/AddSupplier'

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)
dayjs.extend(isBetween);

const API_URL = process.env.REACT_APP_API_URL
const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const TARGET_SALES = process.env.REACT_APP_TARGET_STOCK_SALES
const OPENING_TIME = process.env.REACT_APP_OPENING_TIME
const socket = io('possocket.27mirrors.com')

function isNegative(num: any) {
  if (Math.sign(num) === -1) {
    return true
  }
  return false
}

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Suppliers',
    path: '/suppliers',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

// Interfaces for TypeScript
interface OutstandingPurchase {
  purchase_id: number;
  purchase_number: string;
  total_amount: number;
  amount_paid: number;
  balance_due: number;
  payment_status: string;
  payment_terms: string;
  due_date: any;
  purchase_date: any;
  notes: string;
  status: string;
  created_by_user: string;
}

interface SupplierData {
  supplier_id: number;
  supplier_firstname: string;
  supplier_secondname: string;
  supplier_name: string;
  supplier_phone_number: string;
  supplier_email: string;
  total_purchase_amount: number;
  total_amount_paid: number;
  total_balance_due: number;
  total_purchases: number;
  outstanding_purchases_count: number;
  last_purchase_date: string | null;
  outstanding_purchases: OutstandingPurchase[];
}

interface SupplierSummary {
  date_recordednow: string;
  date_start: string;
  date_end: string;
  total_purchases: number;
  unique_suppliers: number;
  hours_purchasing: number;
  total_purchase_amount: number;
  total_amount_paid: number;
  total_balance_due: number;
  fully_paid_amount: number;
  partially_paid_amount: number;
  unpaid_amount: number;
  fully_paid_count: number;
  partially_paid_count: number;
  unpaid_count: number;
  average_purchase_amount: number;
  highest_purchase_amount: number;
  lowest_purchase_amount: number;
}

interface AllSuppliersResponse {
  suppliers: SupplierData[];
  datalength: number;
  pagination: {
    current_page: number;
    per_page: number;
    total_records: number;
    total_pages: number;
  };
}

interface AllSuppliersApiResponse {
  data: AllSuppliersResponse;
  success?: boolean;
  message?: string;
}

interface SuppliersSummaryApiResponse {
  data: {
    summary_data: SupplierSummary[];
  };
  success?: boolean;
  message?: string;
}

interface CategoryBreakdown {
  [key: string]: {
    count: number;
    totalValue: number;
    totalOutstanding: number;
  };
}

interface SupplierWithValue extends SupplierData {
  supplierValue: number;
}

interface SupplierAnalysis {
  totalSuppliers: number;
  totalPurchaseValue: number;
  totalOutstandingValue: number;
  highValueSuppliers: SupplierData[];
  highOutstandingSuppliers: SupplierData[];
  inactiveSuppliers: SupplierData[];
  categoryBreakdown: CategoryBreakdown;
  averagePurchases: number;
  topSuppliers: SupplierWithValue[];
  riskSuppliers: SupplierData[];
}

const addCommas = (num: any) => {
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  if (isNaN(numValue)) {
    return '0'
  }
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const truncate = require('truncate')

const SuppliersHome: FC = () => {
  const inputRef: any = useRef(null)
  const [time, setTime] = useState<number>(0)
  const queryClientsuppliers = useQueryClient()
  const refloadingbar: any = useRef(null)
  const myRef: any = useRef()
  const myRefsearch: any = useRef()
  const { currentUser, logout } = useAuth()
  const [supplierData, setSupplierData] = useState<SupplierData[]>([])
  const [table1Dataloaded, settable1Dataloaded] = useState(false)
  const [modalshow, setModalshow] = useState(false)
  const [modalSupplierupdateshow, setModalSupplierupdateshow] = useState(false)
  const [currentsearchItems, setCurrentsearchItems] = useState<string>('')
  const [hiddencolumnsmade, setHiddencolumnsmade] = useState<string[]>(['supplier_id'])
  const columndata2 = useMemo(() => [], [])
  const tablename = 'Outstanding Purchases'
  const [modalshowdelete, setModalshowdelete] = useState(false)
  const [modalSupplierShow, setModalSupplierShow] = useState(false)
  const [statedeletingsupplier, setStatedeletingsupplier] = useState(false)
  const [suppliertodelete, setSuppliertodelete] = useState<SupplierData | null>(null)
  const [suppliertoUpdate, setSuppliertoUpdate] = useState<SupplierData | null>(null)
  const [cannotDeletesupplier, setCannotDeletesupplier] = useState<boolean>(false)
  const [statusnow, setStatusnow] = useState<boolean>(false)
  const [statusnow2, setStatusnow2] = useState<boolean>(false)
  const [summaryDatanew, setSummaryDatanew] = useState<any>([])
  const [paginationsize, setPaginationsize] = useState<number>(10)
  const [startlimitsumdash, setStartlimitsumdash] = useState<number>(0)
  const [database_limitsumdash, setDatabase_limitsumdash] = useState<number>(7)
  const [startlimit, setStartlimit] = useState<number>(0)
  const [itemto_order, setItemto_order] = useState<string>('supplier_name')
  const [desorasc, setDesorasc] = useState<string>('ASC')
  const [serversort, setServersort] = useState<any[]>([])
  const [search_item, setSearch_item] = useState<string>('%')
  const [pageCount, setPageCount] = useState<number>(0)
  const [movetofirstpage, setMovetofirstpage] = useState<boolean>(false)
  const onlyWidth = useWindowWidth()
  const hideSupplierModal = useCallback(() => setModalSupplierShow(false), [])
  const showSupplierModal = useCallback(() => setModalSupplierShow(true), [])
  const { showDashboard, toggleDashboard } = useDashboard()

  const {
    isLoading: allsuppliersloading,
    isSuccess: allsupplierssuccess,
    data: allsuppliersdata,
    status: allsuppliersstatus,
    isPreviousData: allsupplierpreviousdata,
    isRefetching: allsuppliersrefetching,
    refetch: allsuppliersrefetch
  } = useSuppliers(
    Number(currentUser?.user_id),
    startlimit,
    paginationsize,
    itemto_order,
    desorasc,
    search_item,
    true
  ) as {
    isLoading: boolean;
    isSuccess: boolean;
    data: AllSuppliersApiResponse | undefined;
    status: string;
    isPreviousData: boolean;
    isRefetching: boolean;
    refetch: () => void;
  }

  const {
    isLoading: summaryloading,
    isSuccess: summarysuccess,
    data: summarydata,
    status: summarystatus,
    isPreviousData: summarypreviousdata,
    isRefetching: summaryrefetching,
    refetch: summaryrefetch
  } = useSuppliersSummary(
    Number(currentUser?.user_id),
    new Date(
      dayjs
        .unix(
          dayjs(
            dayjs().startOf('month').subtract(7, 'days').format('YYYY-MM-DD') + OPENING_TIME
          ).unix()
        )
        .format('YYYY-MM-DD hh:mm')
    ),
    new Date(
      dayjs(dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD') + OPENING_TIME).format(
        'YYYY-MM-DD hh:mm'
      )
    ),
    startlimitsumdash,
    database_limitsumdash
  ) as {
    isLoading: boolean;
    isSuccess: boolean;
    data: SuppliersSummaryApiResponse | undefined;
    status: string;
    isPreviousData: boolean;
    isRefetching: boolean;
    refetch: () => void;
  }

  const {
    isLoading: outstandingloading,
    isSuccess: outstandingsuccess,
    data: outstandingdata,
    refetch: outstandingrefetch
  } = useSuppliersWithOutstandingPayments(
    Number(currentUser?.user_id),
    0,
    10,
    ''
  )

  const { mutateAsync: deleteSuppliermutateAsync } = useDeleteSupplier(
    suppliertodelete?.supplier_id ?? 0,
    Number(currentUser?.user_id)
  )

  // Enhanced download report function similar to customers
  const downloadReport = async (): Promise<void> => {
    try {
      await refloadingbar.current?.continuousStart()
      await allsuppliersrefetch()

      if (!allsuppliersdata?.data?.suppliers) {
        console.log('No supplier data available to export')
        return
      }

      const allSuppliers = allsuppliersdata.data.suppliers.sort((a: SupplierData, b: SupplierData) =>
        (a.supplier_name || '').localeCompare(b.supplier_name || '')
      )

      const analysis: SupplierAnalysis = {
        totalSuppliers: allSuppliers.length,
        totalPurchaseValue: allSuppliers.reduce((sum: number, supplier: SupplierData) =>
          sum + (Number(supplier.total_purchase_amount) || 0), 0),
        totalOutstandingValue: allSuppliers.reduce((sum: number, supplier: SupplierData) =>
          sum + (Number(supplier.total_balance_due) || 0), 0),
        highValueSuppliers: allSuppliers.filter((supplier: SupplierData) =>
          (Number(supplier.total_purchase_amount) || 0) > 50000),
        highOutstandingSuppliers: allSuppliers.filter((supplier: SupplierData) =>
          (Number(supplier.total_balance_due) || 0) > 10000),
        inactiveSuppliers: allSuppliers.filter((supplier: SupplierData) =>
          supplier.last_purchase_date === null || dayjs(supplier.last_purchase_date).isBefore(dayjs().subtract(6, 'month'))),
        categoryBreakdown: {} as CategoryBreakdown,
        averagePurchases: 0,
        topSuppliers: [],
        riskSuppliers: allSuppliers.filter((supplier: SupplierData) =>
          (Number(supplier.total_balance_due) || 0) > (Number(supplier.total_purchase_amount) || 0) * 0.3)
      }

      allSuppliers.forEach((supplier: SupplierData) => {
        const category: string = 'General'
        if (!analysis.categoryBreakdown[category]) {
          analysis.categoryBreakdown[category] = {
            count: 0,
            totalValue: 0,
            totalOutstanding: 0
          }
        }
        analysis.categoryBreakdown[category].count++
        analysis.categoryBreakdown[category].totalValue += (Number(supplier.total_purchase_amount) || 0)
        analysis.categoryBreakdown[category].totalOutstanding += (Number(supplier.total_balance_due) || 0)
      })

      const totalPurchases: number = allSuppliers.reduce((sum: number, supplier: SupplierData) => {
        return sum + (Number(supplier.total_purchase_amount) || 0)
      }, 0)
      analysis.averagePurchases = totalPurchases / allSuppliers.length

      analysis.topSuppliers = allSuppliers
        .map((supplier: SupplierData): SupplierWithValue => ({
          ...supplier,
          supplierValue: (Number(supplier.total_purchase_amount) || 0)
        }))
        .sort((a: SupplierWithValue, b: SupplierWithValue) => b.supplierValue - a.supplierValue)
        .slice(0, 10)

      const wb = XLSX.utils.book_new()

      const supplierDataSheet = allSuppliers.map((supplier: SupplierData) => {
        const purchaseAmount = Number(supplier.total_purchase_amount) || 0
        const outstandingAmount = Number(supplier.total_balance_due) || 0

        let supplierStatus: string = 'Active'
        if (supplier.last_purchase_date === null) supplierStatus = 'Inactive'
        else if (outstandingAmount > purchaseAmount * 0.3) supplierStatus = 'High Risk'

        return {
          'Supplier ID': supplier.supplier_id || '',
          'First Name': supplier.supplier_firstname || '',
          'Second Name': supplier.supplier_secondname || '',
          'Full Name': supplier.supplier_name || '',
          'Phone Number': supplier.supplier_phone_number || '',
          'Email': supplier.supplier_email || '',
          'Total Purchases': purchaseAmount,
          'Total Paid': Number(supplier.total_amount_paid) || 0,
          'Total Outstanding': outstandingAmount,
          'Total Purchase Orders': Number(supplier.total_purchases) || 0,
          'Outstanding Purchases Count': Number(supplier.outstanding_purchases_count) || 0,
          'Last Purchase Date': supplier.last_purchase_date ? dayjs(supplier.last_purchase_date).format('YYYY-MM-DD') : 'N/A',
          'Status': supplierStatus
        }
      })

      const wsSuppliers = XLSX.utils.json_to_sheet(supplierDataSheet)
      XLSX.utils.book_append_sheet(wb, wsSuppliers, "Supplier Data")

      const outstandingPurchasesData = allSuppliers.flatMap((supplier: SupplierData) =>
        (supplier.outstanding_purchases || []).map((purchase: OutstandingPurchase) => ({
          'Supplier ID': supplier.supplier_id,
          'Supplier Name': supplier.supplier_name,
          'Purchase ID': purchase.purchase_id,
          'Purchase Number': purchase.purchase_number,
          'Total Amount': purchase.total_amount,
          'Amount Paid': purchase.amount_paid,
          'Balance Due': purchase.balance_due,
          'Purchase Date': purchase.purchase_date ? dayjs(purchase.purchase_date).format('YYYY-MM-DD') : 'N/A',
          'Payment Status': purchase.payment_status,
          'Payment Terms': purchase.payment_terms,
          'Status': purchase.status,
          'Created By': purchase.created_by_user
        }))
      );

      if (outstandingPurchasesData.length > 0) {
        const wsOutstandingPurchases = XLSX.utils.json_to_sheet(outstandingPurchasesData);
        XLSX.utils.book_append_sheet(wb, wsOutstandingPurchases, "Outstanding Purchases");
      }

      const summaryData = [
        { 'Metric': 'Report Generated', 'Value': dayjs().format('YYYY-MM-DD HH:mm:ss') },
        { 'Metric': 'Total Suppliers', 'Value': analysis.totalSuppliers },
        { 'Metric': 'Total Purchase Value', 'Value': analysis.totalPurchaseValue },
        { 'Metric': 'Total Outstanding Value', 'Value': analysis.totalOutstandingValue },
        { 'Metric': 'Average Purchases per Supplier', 'Value': analysis.averagePurchases },
        { 'Metric': 'High Value Suppliers', 'Value': analysis.highValueSuppliers.length },
        { 'Metric': 'High Outstanding Suppliers', 'Value': analysis.highOutstandingSuppliers.length },
        { 'Metric': 'Inactive Suppliers', 'Value': analysis.inactiveSuppliers.length }
      ]

      const wsSummary = XLSX.utils.json_to_sheet(summaryData)
      XLSX.utils.book_append_sheet(wb, wsSummary, "Executive Summary")

      if (Object.keys(analysis.categoryBreakdown).length > 0) {
        const categoryData = Object.entries(analysis.categoryBreakdown).map(([category, data]) => ({
          'Category': category,
          'Supplier Count': data.count,
          'Total Purchase Value': data.totalValue,
          'Total Outstanding': data.totalOutstanding,
          'Avg Purchases per Supplier': data.totalValue / data.count
        }))

        const wsCategory = XLSX.utils.json_to_sheet(categoryData)
        XLSX.utils.book_append_sheet(wb, wsCategory, "Category Analysis")
      }

      if (analysis.topSuppliers.length > 0) {
        const topSuppliersData = analysis.topSuppliers.map((supplier, index) => ({
          'Rank': index + 1,
          'Supplier Name': supplier.supplier_name,
          'Total Purchases': supplier.supplierValue,
          'Outstanding Amount': supplier.total_balance_due,
          'Purchase Orders': supplier.total_purchases,
          'Phone': supplier.supplier_phone_number
        }))

        const wsTopSuppliers = XLSX.utils.json_to_sheet(topSuppliersData)
        XLSX.utils.book_append_sheet(wb, wsTopSuppliers, "Top Suppliers")
      }

      if (analysis.highOutstandingSuppliers.length > 0 || analysis.riskSuppliers.length > 0) {
        const alertsData = [
          ...analysis.highOutstandingSuppliers.map(supplier => ({
            'Alert Type': 'HIGH OUTSTANDING',
            'Supplier Name': supplier.supplier_name || '',
            'Total Outstanding': Number(supplier.total_balance_due) || 0,
            'Total Purchases': Number(supplier.total_purchase_amount) || 0,
            'Outstanding Purchases': Number(supplier.outstanding_purchases_count) || 0
          })),
          ...analysis.riskSuppliers.map(supplier => ({
            'Alert Type': 'HIGH RISK',
            'Supplier Name': supplier.supplier_name || '',
            'Total Outstanding': Number(supplier.total_balance_due) || 0,
            'Total Purchases': Number(supplier.total_purchase_amount) || 0,
            'Outstanding Purchases': Number(supplier.outstanding_purchases_count) || 0
          }))
        ]

        const wsAlerts = XLSX.utils.json_to_sheet(alertsData)
        XLSX.utils.book_append_sheet(wb, wsAlerts, "Risk Alerts")
      }

      const excelBuffer = XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'array'
      })

      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })

      const link: HTMLAnchorElement = document.createElement('a')
      const url: string = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', `supplier_report_${dayjs().format('YYYY-MM-DD_HH-mm')}.xlsx`)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error generating supplier report:', error)
    } finally {
      refloadingbar.current?.complete()
    }
  }

  // Memoized table data
  const tabledata = useMemo(() => {
    if (allsupplierssuccess && allsuppliersdata?.data?.suppliers) {
      return allsuppliersdata.data.suppliers.map((supplier: SupplierData) => ({
        ...supplier,
        outstanding_purchases: supplier.outstanding_purchases || [],
        subData: supplier.outstanding_purchases || []
      }))
    }
    return []
  }, [allsupplierssuccess, allsuppliersdata])

  const tabledatalength = useMemo(
    () => allsuppliersdata?.data?.datalength || 0,
    [allsuppliersdata?.data?.datalength, allsupplierssuccess]
  )

  // Enhanced search and pagination logic
  useEffect(() => {
    if (!allsupplierpreviousdata) {
      queryClientsuppliers.prefetchQuery(
        ['allsuppliers', startlimit + paginationsize, paginationsize],
        () =>
          getSuppliers(
            Number(currentUser?.user_id),
            startlimit + paginationsize,
            paginationsize,
            itemto_order,
            desorasc,
            search_item,
            true
          )
      )
    }
  }, [
    allsupplierpreviousdata,
    startlimit,
    paginationsize,
    queryClientsuppliers,
    itemto_order,
    desorasc,
    search_item,
  ])

  useEffect(() => {
    const fetchData = async () => {
      try {
        await refloadingbar.current?.continuousStart()
        await allsuppliersrefetch()
      } catch (error) {
        console.log(error)
      } finally {
        refloadingbar.current.complete()
      }
    }
    fetchData()
  }, [itemto_order, desorasc, search_item])

  useEffect(() => {
    const handleValueChange = () => {
      if (myRefsearch.current.value === '' && myRefsearch.current === document.activeElement) {
        setSearch_item('%')
        setPaginationsize(10)
        setStartlimit(0)
        setItemto_order('supplier_name')
        setMovetofirstpage(true)
        setDesorasc('ASC')
      }
    }

    const refSearch = myRefsearch.current
    if (refSearch) {
      refSearch.addEventListener('input', handleValueChange)
    }

    return () => {
      if (refSearch) {
        refSearch.removeEventListener('input', handleValueChange)
      }
    }
  }, [])

  // Enhanced summary data processing
  useEffect(() => {
    if (!summaryrefetching && summarysuccess && summarydata) {

      
      const dataArray = summarydata?.data?.summary_data || [];
      const sorted = [...dataArray].sort((a, b) => (a.date_recordednow > b.date_recordednow ? -1 : 1));
      if (sorted.length > 0) {
        if (dayjs(dayjs(sorted[0].date_recordednow).format('YYYY-MM-DD')).unix() === dayjs(dayjs().format('YYYY-MM-DD')).unix()) {
          setSummaryDatanew(dataArray)
        } else {
          if (
            dayjs(dayjs(sorted[0].date_recordednow).format('YYYY-MM-DD')).unix() === dayjs(dayjs().subtract(1, 'days').format('YYYY-MM-DD')).unix() &&
            dayjs(dayjs().format("YYYY-MM-DD, h:mm:ss a")).unix() <= dayjs(dayjs().format('YYYY-MM-DD') + OPENING_TIME).unix()
          ) {
            setSummaryDatanew(dataArray)
          } else {
            const currentitemsobj2: SupplierSummary = {
              date_recordednow: dayjs().format('YYYY-MM-DD'),
              date_start: dayjs().format('YYYY-MM-DD'),
              date_end: dayjs().format('YYYY-MM-DD'),
              total_purchases: 0,
              unique_suppliers: 0,
              hours_purchasing: 0,
              total_purchase_amount: 0,
              total_amount_paid: 0,
              total_balance_due: 0,
              fully_paid_amount: 0,
              partially_paid_amount: 0,
              unpaid_amount: 0,
              fully_paid_count: 0,
              partially_paid_count: 0,
              unpaid_count: 0,
              average_purchase_amount: 0,
              highest_purchase_amount: 0,
              lowest_purchase_amount: 0
            }
            setSummaryDatanew([...dataArray, currentitemsobj2])
          }
        }
      } else {
        const currentitemsobj2: SupplierSummary = {
          date_recordednow: dayjs().format('YYYY-MM-DD'),
          date_start: dayjs().format('YYYY-MM-DD'),
          date_end: dayjs().format('YYYY-MM-DD'),
          total_purchases: 0,
          unique_suppliers: 0,
          hours_purchasing: 0,
          total_purchase_amount: 0,
          total_amount_paid: 0,
          total_balance_due: 0,
          fully_paid_amount: 0,
          partially_paid_amount: 0,
          unpaid_amount: 0,
          fully_paid_count: 0,
          partially_paid_count: 0,
          unpaid_count: 0,
          average_purchase_amount: 0,
          highest_purchase_amount: 0,
          lowest_purchase_amount: 0
        }
        setSummaryDatanew([currentitemsobj2])
      }
    }
  }, [summaryrefetching, summarysuccess, summarydata])

  useEffect(() => {
    if (serversort.length > 0) {
      setItemto_order(serversort[0].id)
      setDesorasc(serversort[0].desc ? 'DESC' : 'ASC')
    } else {
      setItemto_order('supplier_name')
      setDesorasc('ASC')
    }
  }, [serversort])

  useEffect(() => {
    if (summarysuccess) {
      setStatusnow(true)
    }
  }, [summarysuccess])

  useEffect(() => {
    if (statusnow && !summaryrefetching) {
      setStatusnow2(true)
    }
  }, [summaryrefetching, statusnow])

  // Column definitions for main table - desktop
  const columndata1 = useMemo<Column<SupplierData>[]>(
    () => [
      {
        Header: () => null,
        id: 'expander',
        Cell: ({ row }: any) => {
          const supplier = row.original as SupplierData;
          if ((supplier.outstanding_purchases || []).length > 0) {
            return (
              <span {...row.getToggleRowExpandedProps()}>
                {row.isExpanded ? (
                  <span className='svg-icon svg-icon-primary'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                ) : (
                  <span className='svg-icon svg-icon-primary'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                )}
              </span>
            )
          }
          return null
        },
      },
      {
        Header: 'Name',
        accessor: 'supplier_name',
        Cell: ({ cell: { value }, row }) => (
          <div className='d-flex align-items-center'>
            <div className='symbol symbol-50px me-5'>
              <div className='symbol-label bg-light'>
                <img
                  src={toAbsoluteUrl('/media/icons/duotune/ecommerce/ecm006.svg')}
                  alt=''
                  className='h-100'
                />
              </div>
            </div>
            <div className='d-flex justify-content-start flex-column'>
              <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap' title={row.original.supplier_name}>
                {truncate(row.original.supplier_name, 20)}
              </span>
              <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
                {row.original.supplier_phone_number}
              </span>
              <span className='badge badge-light-dark me-1' title={row.original.supplier_email}>
                {truncate(row.original.supplier_email, 20)}
              </span>
            </div>
          </div>
        ),
      },
      {
        Header: 'T.Purchases',
        accessor: 'total_purchase_amount',
        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap' title={row.original.supplier_name}>
              {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
            </span>
            <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
              Paid: {addCommas(row.original.total_amount_paid)} {CURRENCY_APP}
            </span>
          </>
        ),
      },
      {
        Header: 'Outstanding',
        accessor: 'total_balance_due',
        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary fw-bolder fs-6 text-nowrap'>
              {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
            </span>
            <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
              Purchases: {addCommas(row.original.outstanding_purchases_count)}
            </span>
          </>
        ),
      },
      {
        Header: 'id',
        accessor: 'supplier_id',
        Cell: ({ cell: { value } }) => (
          <span className='text-primary fw-bolder fs-6 text-nowrap'>
            {value}
          </span>
        ),
      },
      {
        Header: () => null,
        id: 'expander2',
        Cell: ({ row }: any) => (
          <div className='d-flex justify-content-end flex-shrink-0'>
            <a
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
              onClick={() => showsupplierupdateModal(row.original)}
            >
              <span className='svg-icon svg-icon-3'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                >
                  <path
                    opacity='0.3'
                    d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                    fill='black'
                  ></path>
                  <path
                    d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                    fill='black'
                  ></path>
                </svg>
              </span>
            </a>
            <a
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
              onClick={() => showModaldelete(row.original)}
            >
              <span className='svg-icon svg-icon-3'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width={24}
                  height={24}
                  viewBox='0 0 24 24'
                  fill='none'
                >
                  <path
                    d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                    fill='#f1416c'
                  />
                  <path
                    opacity='0.5'
                    d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                    fill='#f1416c'
                  />
                  <path
                    opacity='0.5'
                    d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                    fill='#f1416c'
                  />
                </svg>
              </span>
            </a>
          </div>
        ),
      },
    ],
    []
  );

  // Mobile columns
  const columndata3 = useMemo<Column<SupplierData>[]>(
    () => [
      {
        Header: () => null,
        id: 'expander',
        Cell: ({ row }: any) => {
          const supplier = row.original as SupplierData;
          if ((supplier.outstanding_purchases || []).length > 0) {
            return (
              <span {...row.getToggleRowExpandedProps()}>
                {row.isExpanded ? (
                  <span className='svg-icon svg-icon-primary'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                ) : (
                  <span className='svg-icon svg-icon-primary'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                )}
              </span>
            )
          }
          return null
        },
      },
      {
        Header: 'Name',
        accessor: 'supplier_name',
        Cell: ({ cell: { value }, row }) => (
          <div className='d-flex align-items-center'>
            <div className='d-flex justify-content-start flex-column'>
              <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap' title={row.original.supplier_name}>
                {truncate(row.original.supplier_name, 15)}
              </span>
              <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
                {row.original.supplier_phone_number}
              </span>
              <span className='badge badge-light-dark me-1' title={row.original.supplier_email}>
                {truncate(row.original.supplier_email, 20)}
              </span>
            </div>
          </div>
        ),
      },
      {
        Header: 'id',
        accessor: 'supplier_id',
        Cell: ({ cell: { value } }) => (
          <span className='text-primary fw-bolder fs-6 text-nowrap'>
            {value}
          </span>
        ),
      },
      {
        Header: () => null,
        id: 'expander2',
        Cell: ({ row }: any) => (
          <div className='d-flex justify-content-end flex-shrink-0'>
            <a
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
              onClick={() => showsupplierupdateModal(row.original)}
            >
              <span className='svg-icon svg-icon-3'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                >
                  <path
                    opacity='0.3'
                    d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                    fill='black'
                  ></path>
                  <path
                    d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                    fill='black'
                  ></path>
                </svg>
              </span>
            </a>
            <a
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
              onClick={() => showModaldelete(row.original)}
            >
              <span className='svg-icon svg-icon-3'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width={24}
                  height={24}
                  viewBox='0 0 24 24'
                  fill='none'
                >
                  <path
                    d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                    fill='#f1416c'
                  />
                  <path
                    opacity='0.5'
                    d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                    fill='#f1416c'
                  />
                  <path
                    opacity='0.5'
                    d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                    fill='#f1416c'
                  />
                </svg>
              </span>
            </a>
          </div>
        ),
      },
    ],
    []
  );

  // Tablet columns
  const columndata5 = useMemo<Column<SupplierData>[]>(
    () => [
      {
        Header: () => null,
        id: 'expander',
        Cell: ({ row }: any) => {
          const supplier = row.original as SupplierData;
          if ((supplier.outstanding_purchases || []).length > 0) {
            return (
              <span {...row.getToggleRowExpandedProps()}>
                {row.isExpanded ? (
                  <span className='svg-icon svg-icon-primary'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                ) : (
                  <span className='svg-icon svg-icon-primary'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                )}
              </span>
            )
          }
          return null
        },
      },
      {
        Header: 'Name',
        accessor: 'supplier_name',
        Cell: ({ cell: { value }, row }) => (
          <div className='d-flex align-items-center'>
            <div className='symbol symbol-50px me-5'>
              <div className='symbol-label bg-light'>
                <img
                  src={toAbsoluteUrl('/media/icons/duotune/ecommerce/ecm006.svg')}
                  alt=''
                  className='h-100'
                />
              </div>
            </div>
            <div className='d-flex justify-content-start flex-column'>
              <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap' title={row.original.supplier_name}>
                {truncate(row.original.supplier_name, 20)}
              </span>
              <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
                {row.original.supplier_phone_number}
              </span>
              <span className='badge badge-light-dark d-block me-1' title={row.original.supplier_email}>
                {truncate(row.original.supplier_email, 20)}
              </span>
            </div>
          </div>
        ),
      },
      {
        Header: 'T.Purchases',
        accessor: 'total_purchase_amount',
        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark fw-bolder d-block mb-1 fs-6 text-nowrap'>
              {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
            </span>
            <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
              Paid: {addCommas(row.original.total_amount_paid)} {CURRENCY_APP}
            </span>
          </>
        ),
      },
      {
        Header: 'Outstanding',
        accessor: 'total_balance_due',
        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary fw-bolder fs-6 text-nowrap'>
              {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
            </span>
            <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
              Purchases: {addCommas(row.original.outstanding_purchases_count)}
            </span>
          </>
        ),
      },
      {
        Header: 'id',
        accessor: 'supplier_id',
        Cell: ({ cell: { value } }) => (
          <span className='text-primary fw-bolder fs-6 text-nowrap'>
            {value}
          </span>
        ),
      },
      {
        Header: () => null,
        id: 'expander2',
        Cell: ({ row }: any) => (
          <div className='d-flex justify-content-end flex-shrink-0'>
            <a
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
              onClick={() => showsupplierupdateModal(row.original)}
            >
              <span className='svg-icon svg-icon-3'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                >
                  <path
                    opacity='0.3'
                    d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                    fill='black'
                  ></path>
                  <path
                    d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                    fill='black'
                  ></path>
                </svg>
              </span>
            </a>
            <a
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
              onClick={() => showModaldelete(row.original)}
            >
              <span className='svg-icon svg-icon-3'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width={24}
                  height={24}
                  viewBox='0 0 24 24'
                  fill='none'
                >
                  <path
                    d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                    fill='#f1416c'
                  />
                  <path
                    opacity='0.5'
                    d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                    fill='#f1416c'
                  />
                  <path
                    opacity='0.5'
                    d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                    fill='#f1416c'
                  />
                </svg>
              </span>
            </a>
          </div>
        ),
      },
    ],
    []
  );

  // Sub-table columns for outstanding purchases - desktop
  const columndata2sub = useMemo<Column<OutstandingPurchase>[]>(
    () => [
      {
        Header: 'ID',
        accessor: 'purchase_number',
        Cell: ({ cell: { value } }) => (
          <span className='text-primary fw-bolder fs-6 text-nowrap'>
            {value}
          </span>
        ),
      },
      {
        Header: 'Total',
        accessor: 'total_amount',
        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>
            <span className='text-muted text-nowrap fw-bold text-muted d-block fs-7'>
              <span
                className={`${
                  row.original.payment_status === 'PAID'
                    ? 'badge badge-light-success'
                    : row.original.payment_status === 'PARTIAL'
                    ? 'badge badge-light-warning'
                    : row.original.payment_status === 'CREDIT'
                    ? 'badge badge-light-info'
                    : 'badge badge-light-primary'
                }`}
              >
                {row.original.payment_status}
              </span>
            </span>
          </>
        ),
      },
      {
        Header: 'O.Amount',
        accessor: 'balance_due',
        Cell: ({ row }) => {
          const purchase = row.original;
          return (
            <>
              <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
                {addCommas(Number(purchase.balance_due).toFixed(2))} {CURRENCY_APP}
              </span>
              <span className='text-muted text-nowrap fw-bold text-muted d-block fs-7'>
                {addCommas(Number(purchase.amount_paid).toFixed(2))} {CURRENCY_APP}
              </span>
            </>
          );
        },
      },
      {
        Header: 'Date',
        accessor: 'purchase_date',
        Cell: ({ cell: { value } }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {value ? dayjs(value).format('LL') : 'N/A'}
            </span>
            <span className='text-muted text-nowrap fw-bold text-muted d-block fs-7'>
              {value ? `${dayjs(value).format('dddd')}, ${dayjs(value).format('LTS')}` : 'N/A'}
            </span>
          </>
        ),
      },
      {
        Header: 'Status',
        accessor: 'payment_status',
        Cell: ({ row }) => {
          const purchase = row.original;
          
          const getBadgeStyles = (status: any) => {
            switch (status) {
              case 'PAID':
                return 'badge badge-light-success';
              case 'PARTIAL':
                return 'badge badge-light-warning text-dark';
              case 'CREDIT':
                return 'badge badge-light-info';
              case 'NOT PAID':
                return 'badge badge-light-danger';
              default:
                return 'badge badge-light-secondary';
            }
          };
      
          return (
            <span className={getBadgeStyles(purchase.payment_status)}>
              {purchase.payment_status}
            </span>
          );
        }
      },
      {
        Header: 'Created By',
        accessor: 'created_by_user',
      },
    ],
    []
  );

  // Sub-table mobile
  const columndata4sub = useMemo<Column<OutstandingPurchase>[]>(
    () => [
      {
        Header: 'ID',
        accessor: 'purchase_number',
        Cell: ({ row }) => {
          const purchase = row.original;
          return (
            <>
              <span className='text-primary fw-bolder fs-6 text-nowrap'>
                {purchase.purchase_number}
              </span>
              <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
                Outstanding: {addCommas(Number(purchase.balance_due).toFixed(2))} {CURRENCY_APP}
              </span>
            </>
          )
        },
      },
      {
        Header: 'Status',
        accessor: 'payment_status',
        Cell: ({ row }) => {
          const purchase = row.original;
          
          const getBadgeStyles = (status: any) => {
            switch (status) {
              case 'PAID':
                return 'badge badge-light-success';
              case 'PARTIAL':
                return 'badge badge-light-warning text-dark';
              case 'CREDIT':
                return 'badge badge-light-info';
              case 'NOT PAID':
                return 'badge badge-light-danger';
              default:
                return 'badge badge-light-secondary';
            }
          };
      
          return (
            <span className={getBadgeStyles(purchase.payment_status)}>
              {purchase.payment_status}
            </span>
          );
        }
      },
    ],
    []
  );

  // Sub-table tablet
  const columndata6sub = useMemo<Column<OutstandingPurchase>[]>(
    () => [
      {
        Header: 'ID',
        accessor: 'purchase_number',
        Cell: ({ cell: { value } }) => (
          <span className='text-primary fw-bolder fs-6 text-nowrap'>
            {value}
          </span>
        ),
      },
      {
        Header: 'Total',
        accessor: 'total_amount',
        Cell: ({ cell: { value }, row }) => {
          const purchase = row.original;
          const getBadgeStyles = (status: any) => {
            switch (status) {
              case 'PAID':
                return 'badge badge-light-success';
              case 'PARTIAL':
                return 'badge badge-light-warning text-dark';
              case 'CREDIT':
                return 'badge badge-light-info';
              case 'NOT PAID':
                return 'badge badge-light-danger';
              default:
                return 'badge badge-light-secondary';
            }
          };
          return (
            <>
              <span className='text-dark fw-bolder fs-6 text-nowrap'>
                {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
              </span>
              <span className='text-muted fw-bold text-muted d-block fs-7 text-nowrap'>
                {addCommas(
                  Number(purchase.balance_due).toFixed(2)
                )} {CURRENCY_APP}
              </span>
            </>
          )
        }
      },
      {
        Header: 'Date',
        accessor: 'purchase_date',
        Cell: ({ cell: { value } }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {value ? dayjs(value).format('LL') : 'N/A'}
            </span>
            <span className='text-muted text-nowrap fw-bold text-muted d-block fs-7'>
              {value ? `${dayjs(value).format('dddd')}, ${dayjs(value).format('LTS')}` : 'N/A'}
            </span>
          </>
        ),
      },
      {
        Header: 'Status',
        accessor: 'payment_status',
        Cell: ({ row }) => {
          const purchase = row.original;
          
          const getBadgeStyles = (status: any) => {
            switch (status) {
              case 'PAID':
                return 'badge badge-light-success';
              case 'PARTIAL':
                return 'badge badge-light-warning text-dark';
              case 'CREDIT':
                return 'badge badge-light-info';
              case 'NOT PAID':
                return 'badge badge-light-danger';
              default:
                return 'badge badge-light-secondary';
            }
          };
      
          return (
            <span className={getBadgeStyles(purchase.payment_status)}>
              {purchase.payment_status}
            </span>
          );
        }
      },
    ],
    []
  );

  // Helper functions for filtering sub data
  const filteredsubdata = (rowdata: any): number => {
    const supplier = rowdata.original as SupplierData;
    return (supplier.outstanding_purchases || []).length;
  }

  const filteredtablesubData = (rowdata: any): OutstandingPurchase[] => {
    const supplier = rowdata.original as SupplierData;
    return (supplier.outstanding_purchases || []).sort((a, b) => {
      const dateA = a.purchase_date ? dayjs(a.purchase_date).valueOf() : 0;
      const dateB = b.purchase_date ? dayjs(b.purchase_date).valueOf() : 0;
      return dateB - dateA;
    });
  }

  const deleteselectedsupplier = async () => {
    if (!suppliertodelete) return
    setStatedeletingsupplier(true)
    setCannotDeletesupplier(false)
    deleteSuppliermutateAsync(undefined, {
      onSuccess: () => {
        setStatedeletingsupplier(false)
        setModalshowdelete(false)
      },
      onError(error) {
        console.log(error)
        setStatedeletingsupplier(false)
        setCannotDeletesupplier(true)
      },
    })
  }

  const showModaldelete = (x: SupplierData) => {
    setModalshowdelete(true)
    setStatedeletingsupplier(false)
    setCannotDeletesupplier(false)
    setSuppliertodelete(x)
  }

  const showModal = () => {
    setModalshow(true)
  }

  const showsupplierupdateModal = (x: SupplierData) => {
    setSuppliertoUpdate(x)
    setModalSupplierupdateshow(true)
  }

  const handlesearchKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      const inputValue = (event.target as HTMLInputElement).value
      if (inputValue) {
        setSearch_item(inputValue + '%')
      } else {
        setSearch_item('%')
      }
      setPaginationsize(10)
      setStartlimit(0)
      setItemto_order('supplier_name')
      setMovetofirstpage(true)
      setDesorasc('ASC')
    }
  }

  const handlesearchKeyDown2 = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    const inputValue = myRefsearch.current.value
    if (inputValue) {
      setSearch_item(inputValue + '%')
    } else {
      setSearch_item('%')
    }
    setPaginationsize(10)
    setStartlimit(0)
    setItemto_order('supplier_name')
    setMovetofirstpage(true)
    setDesorasc('ASC')
  }

  const handleinputs = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === '') {
      setSearch_item('%')
      setPaginationsize(10)
      setStartlimit(0)
      setItemto_order('supplier_name')
      setMovetofirstpage(true)
      setDesorasc('ASC')
    }
  }

  // Socket updates
  socket.on('update', (_arg: any) => {
    (async () => {
      try {
        await refloadingbar.current?.continuousStart()
        await allsuppliersrefetch()
        await summaryrefetch()
        await outstandingrefetch()
      } catch (error) {
        console.log(error)
      } finally {
        await refloadingbar.current?.complete()
      }
    })()
  })

  return (
    <>
      <LoadingBar color='#009ef7' ref={refloadingbar} />
      <PageTitle breadcrumbs={usersBreadcrumbs}>Suppliers Dashboard</PageTitle>
      
      {/* Summary Cards - Adapted from customers */}
      {showDashboard && (
        <div className='row g-5 g-xl-8'>
          
          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-xl-8'
              chartColor='success'
              chartHeight='120px'
              cardName='T.Purchases'
              chartName='Purchase Amount'
              statusnow={statusnow}
              statusnow2={statusnow2}
              yaxisHeight={summaryDatanew && summaryDatanew.length > 0 ? Math.abs(Math.max(...(summaryDatanew.map((x: any) => x.total_purchase_amount || 0)))) : 100}
              chartCategories={summaryDatanew && summaryDatanew.length > 0 ? summaryDatanew
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => dayjs(x.date_recordednow).format('LL')) : []}
              chartData={summaryDatanew && summaryDatanew.length > 0 ? summaryDatanew
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => x.total_purchase_amount || 0) : []}
              values={
                <div className='fs-2 fw-bolder d-block'>
                  <CountUp
                    className='text-success'
                    end={summaryDatanew && summaryDatanew.length > 0
                      ? summaryDatanew
                          .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? -1 : 1))[0]?.total_purchase_amount || 0
                      : 0}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup className='fs-6 text-success'>{CURRENCY_APP}</sup>
                </div>
              }
              values2={
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {summaryDatanew[1]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-success'>
                              {dayjs(summaryDatanew[1].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={summaryDatanew[1].total_purchase_amount}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      )}
                      {summaryDatanew[2]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-success'>
                              {dayjs(summaryDatanew[2].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={summaryDatanew[2].total_purchase_amount}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </span>
              }
            />
          </div>
          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-5 mb-xl-8'
              chartColor='danger'
              chartHeight='120px'
              statusnow={statusnow}
              statusnow2={statusnow2}
              cardName='T.Balance'
              chartName='Balance Due'
              yaxisHeight={summaryDatanew && summaryDatanew.length > 0 ? Math.abs(Math.max(...(summaryDatanew.map((x: any) => x.total_balance_due || 0)))) : 100}
              chartCategories={summaryDatanew && summaryDatanew.length > 0 ? summaryDatanew
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => dayjs(x.date_recordednow).format('LL')) : []}
              chartData={summaryDatanew && summaryDatanew.length > 0 ? summaryDatanew
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => x.total_balance_due || 0) : []}
              values={
                <div className='fs-2 fw-bolder'>
                  <CountUp
                    className='text-danger'
                    end={summaryDatanew && summaryDatanew.length > 0
                      ? summaryDatanew
                          .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? -1 : 1))[0]?.total_balance_due || 0
                      : 0}
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup className='text-danger fs-6'>{CURRENCY_APP}</sup>
                </div>
              }
              values2={
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {summaryDatanew[1]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-danger'>
                              {dayjs(summaryDatanew[1].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={summaryDatanew[1].total_balance_due}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      )}
                      {summaryDatanew[2]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-danger'>
                              {dayjs(summaryDatanew[2].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={summaryDatanew[2].total_balance_due}
                              duration={2}
                              decimals={2}
                              separator=','
                            />{' '}
                            <sup className='text-muted'>{CURRENCY_APP}</sup>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </span>
              }
            />
          </div>
          <div className='col-xl-4'>
            <ItemsSummary
              className='card-xl-stretch mb-xl-8'
              chartColor='primary'
              chartHeight='120px'
              cardName='T.Suppliers'
              chartName='Supplier Growth'
              statusnow={statusnow}
              statusnow2={statusnow2}
              isCurrency= {false}
              yaxisHeight={summaryDatanew && summaryDatanew.length > 0 ? Math.abs(Math.max(...(summaryDatanew.map((x: any) => x.unique_suppliers || 0)))) : 100}
              chartCategories={summaryDatanew && summaryDatanew.length > 0 ? summaryDatanew
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => dayjs(x.date_recordednow).format('LL')) : []}
              chartData={summaryDatanew && summaryDatanew.length > 0 ? summaryDatanew
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => x.unique_suppliers || 0) : []}
              values={
                <div className='fs-2 fw-bolder d-block'>
                  <CountUp
                    className='text-primary'
                    end={summaryDatanew && summaryDatanew.length > 0 
                      ? summaryDatanew
                          .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? -1 : 1))[0]?.unique_suppliers || 0
                      : 0}
                    duration={2}
                    decimals={0}
                    separator=','
                  />
                </div>
              }
              values2={
                <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                  <table>
                    <tbody>
                      {summaryDatanew[1]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-primary'>
                              {dayjs(summaryDatanew[1].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={summaryDatanew[1].unique_suppliers}
                              duration={2}
                              decimals={0}
                              separator=','
                            />
                          </td>
                        </tr>
                      )}
                      {summaryDatanew[2]?.date_recordednow && (
                        <tr>
                          <td>
                            <span className='badge badge-light-primary'>
                              {dayjs(summaryDatanew[2].date_recordednow).calendar(null, {
                                sameDay: '[Today]',
                                nextDay: '[Tomorrow]',
                                nextWeek: 'dddd',
                                lastDay: '[Yesterday]',
                                lastWeek: 'dddd',
                                sameElse: 'DD/MM/YYYY',
                              })}
                            </span>
                          </td>
                          <td>
                            <span className='h-20px border-gray-200 border-start mx-2'></span>
                            <CountUp
                              className='text-bold text-muted'
                              end={summaryDatanew[2].unique_suppliers}
                              duration={2}
                              decimals={0}
                              separator=','
                            />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </span>
              }
            />
          </div>
        </div>
      )}

      <KTCard>
        <KTCardBody className='py-4'>
          <div className='row mt-4'>
            <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'>
              <div className='mb-2'>
                <h3 className='fw-bolder my-2'>Update Supplier</h3>          
              </div>
            </div>
            <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
              <div className='mb-2'>
                <div className='d-flex align-items-center position-relative my-1'>
                  <a href='#' onClick={handlesearchKeyDown2}>
                    <KTSVG
                      path='/media/icons/duotune/general/gen021.svg'
                      className='svg-icon-1 position-absolute me-4 top-0 end-0 mt-3 text-primary'
                    />
                  </a>
                  <input
                    type='text'
                    data-kt-user-table-filter='search'
                    className='form-control form-control-solid w-250px ps-5 pe-12'
                    placeholder='Search Suppliers'
                    ref={myRefsearch}
                    onChange={handleinputs}
                    onKeyDown={handlesearchKeyDown}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12 col-md-12 d-flex align-items-center justify-content-center justify-content-md-start'>
              <div className='mb-2 me-auto'>
                <a
                  className='btn btn-info btn-sm mb-2 me-2'
                  href='#'
                  onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                    e.preventDefault()
                    downloadReport()
                  }}
                >
                  <KTSVG path='/media/icons/duotune/files/fil002.svg' className='svg-icon-1' />
                  {onlyWidth <= 576 ? '↓' : 'Download Report'}
                </a>
              </div>
              <div className='mb-2' style={{ display: 'inline-grid', gridTemplateColumns: '1fr' }}>
                <a
                  className='btn btn-success btn-sm mb-2 me-2'
                  href='#'
                  onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                    e.preventDefault()
                    showSupplierModal();
                  }}
                  title={onlyWidth <= 576 ? 'Add Supplier' : ''}
                >
                  <KTSVG path='/media/icons/duotune/ecommerce/ecm006.svg' className='svg-icon-1' />
                  {onlyWidth <= 576 ? '+' : 'Add Supplier'}
                </a>
              </div>
            </div>
          </div>
          <Maintable
            tabledata={allsupplierssuccess ? tabledata : []}
            startlimit={startlimit}
            hiddencolumnsmade={hiddencolumnsmade}
            setstartlimit={setStartlimit}
            paginationsize={paginationsize}
            pageCount={pageCount}
            setPageCount={setPageCount}
            setPaginationsize={setPaginationsize}
            columndata={onlyWidth <= 576 ? columndata3 : onlyWidth > 576 && onlyWidth <= 768 ? columndata5 : columndata1}
            tabledata2={tabledata}
            columndata2={onlyWidth <= 576 ? columndata4sub : onlyWidth > 576 && onlyWidth <= 768 ? columndata6sub : columndata2sub}
            table1loaded={allsuppliersstatus === 'success'}
            table2loaded={allsuppliersstatus === 'success'}
            movetofirstpage={movetofirstpage}
            setMovetofirstpage={setMovetofirstpage}
            tablename={tablename}
            tablelength={allsuppliersstatus === 'success' ? tabledatalength : 0}
            filteredsubdata={filteredsubdata}
            filteredtablesubData={filteredtablesubData}
            setServersort={setServersort}
          />
        </KTCardBody>
      </KTCard>

      {modalSupplierShow && <AddSupplier show={modalSupplierShow} handleClose={hideSupplierModal} />}
      {modalSupplierupdateshow && suppliertoUpdate && (
        <Updatesupplier
          show={modalSupplierupdateshow}
          suppliertoUpdate={suppliertoUpdate}
          allsuppliersrefetch={allsuppliersrefetch}
          summaryrefetch={summaryrefetch}
          outstandingrefetch={outstandingrefetch}
          handleClose={() => setModalSupplierupdateshow(false)}
        />
      )}
      {modalshowdelete && suppliertodelete && (
        <Deletesupplier
          show={modalshowdelete}
          deleteselectedsupplier={deleteselectedsupplier}
          suppliertodelete={suppliertodelete}
          statedeletingsupplier={statedeletingsupplier}
          cannotDeletesupplier={cannotDeletesupplier}
          handleClose={() => setModalshowdelete(false)}
        />
      )}
    </>
  )
}

export default SuppliersHome